/**
 * Оверлей поиска в шапке: открытие, закрытие, история запросов.
 */
class SearchOverlay {

    /**
     * Находит разметку оверлея и навешивает обработчики.
     */
    constructor() {
        this.overlay = document.querySelector('[data-search-overlay]');
        this.openButtons = document.querySelectorAll('[data-search-overlay-open]');
        this.input = this.overlay ? this.overlay.querySelector('.search-overlay__input') : null;
        this.form = this.overlay ? this.overlay.querySelector('.search-overlay__search') : null;
        this.dropdown = this.overlay ? this.overlay.querySelector('.search-overlay__dropdown') : null;
        this.storageKey = 'nft-search-history';
        this.historyLimit = 10;

        if (!this.overlay) {
            return;
        }

        this.saveQuery(this.input ? this.input.value : '');
        this.renderHistory();
        this.bindOpen();
        this.bindClear();
        this.bindReturn();
        this.bindEscape();
        this.bindBackdrop();
        this.bindSubmit();
    }

    /**
     * Открывает оверлей и ставит фокус в поле.
     */
    open() {
        this.renderHistory();
        this.overlay.classList.add('search-overlay--open');
        this.overlay.removeAttribute('hidden');
        this.overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => {
            if (this.input) {
                this.input.focus();
            }
        });
    }

    /**
     * Закрывает оверлей и возвращает прокрутку страницы.
     */
    close() {
        this.overlay.classList.remove('search-overlay--open');
        this.overlay.setAttribute('hidden', '');
        this.overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = 'auto';
    }

    /**
     * Переключает видимость оверлея.
     */
    toggle() {
        if (this.overlay.classList.contains('search-overlay--open')) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Вешает обработчики на кнопки открытия.
     */
    bindOpen() {
        this.openButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.toggle();
            });
        });
    }

    /**
     * Очищает поле по кнопке «Отменить».
     */
    bindClear() {
        this.overlay.querySelectorAll('[data-search-overlay-clear]').forEach((button) => {
            button.addEventListener('click', () => {
                if (this.input) {
                    this.input.value = '';
                    this.input.focus();
                }
            });
        });
    }

    /**
     * Закрывает оверлей по кнопке «назад» (search-overlay__return).
     */
    bindReturn() {
        const button = this.overlay.querySelector('.search-overlay__return');

        if (!button) {
            return;
        }

        button.addEventListener('click', (event) => {
            event.preventDefault();
            this.close();
        });
    }

    /**
     * Закрывает оверлей по Escape.
     */
    bindEscape() {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.overlay.classList.contains('search-overlay--open')) {
                this.close();
            }
        });
    }

    /**
     * Закрывает оверлей по клику на затемнение.
     */
    bindBackdrop() {
        this.overlay.addEventListener('click', (event) => {
            if (event.target === this.overlay) {
                this.close();
            }
        });
    }

    /**
     * Сохраняет запрос в историю перед отправкой формы поиска.
     */
    bindSubmit() {
        if (!this.form) {
            return;
        }

        this.form.addEventListener('submit', () => {
            if (this.input) {
                this.saveQuery(this.input.value);
            }
        });
    }

    /**
     * Читает последние запросы пользователя из localStorage.
     */
    getHistory() {
        try {
            const raw = window.localStorage.getItem(this.storageKey);
            const parsed = raw ? JSON.parse(raw) : [];

            if (!Array.isArray(parsed)) {
                return [];
            }

            return parsed.filter((item) => typeof item === 'string' && item !== '').slice(0, this.historyLimit);
        } catch (error) {
            return [];
        }
    }

    /**
     * Добавляет запрос в начало истории и обрезает список до 10.
     */
    saveQuery(raw) {
        const query = raw.trim();

        if (query === '') {
            return;
        }

        const queries = this.getHistory().filter((item) => item.toLowerCase() !== query.toLowerCase());
        queries.unshift(query);

        window.localStorage.setItem(this.storageKey, JSON.stringify(queries.slice(0, this.historyLimit)));
    }

    /**
     * Рисует последние запросы в search-overlay__dropdown.
     */
    renderHistory() {
        if (!this.dropdown || !this.form) {
            return;
        }

        const queries = this.getHistory();
        this.dropdown.replaceChildren();

        if (!queries.length) {
            this.dropdown.setAttribute('hidden', '');
            return;
        }

        queries.forEach((query) => {
            this.dropdown.appendChild(this.createHistoryLink(query));
        });

        this.dropdown.removeAttribute('hidden');
    }

    /**
     * Собирает ссылку на результаты поиска по сохранённому запросу.
     */
    createHistoryLink(query) {
        const action = this.form.getAttribute('action') || '/';
        const url = new URL(action, window.location.origin);
        url.searchParams.set('s', query);

        const link = document.createElement('a');
        link.className = 'search-overlay__query';
        link.href = `${url.pathname}${url.search}`;

        const text = document.createElement('span');
        text.className = 'search-overlay__query-text';
        text.textContent = query;
        link.appendChild(text);

        return link;
    }
}

export default SearchOverlay;
